// Cookieless funnel + share instrumentation. Rationale: README.md ("Measurement").
//
// Must route through the `utils/analytics` facade, NOT `@vercel/analytics`
// directly: the facade buffers events fired before <Analytics/> mounts (idle,
// up to 5s), and raw `track` that early is a silent no-op that would drop the
// mount-time entry events entirely.
import { analytics } from 'lib/analytics/analytics';
import type { Mood } from './types';

/**
 * PRIVACY: props are locked per-event to non-identifying categoricals, so the
 * compiler rejects any attempt to pass user-entered text (name, city,
 * greeting). Keep it that way — adding a prop here is the only way in.
 */
type EmeraldEventProps = {
  emerald_enter: undefined; // fresh/direct visit to the experience
  emerald_shared_link_opened: undefined; // a recipient opened a shared link (?name/?shared)
  emerald_orb_charged: undefined; // press-and-hold completed (Act 1 done)
  emerald_name_submitted: undefined; // typed a name and continued
  emerald_name_skipped: undefined; // skipped the name step
  emerald_sky_resolved: { method: 'geo' | 'city' | 'skip' }; // reached insights
  emerald_share_clicked: { mood: Mood }; // tapped SHARE (the virality signal)
  emerald_image_saved: { mood: Mood }; // tapped SAVE IMAGE
};

export type EmeraldEvent = keyof EmeraldEventProps;

export function trackEmerald<E extends EmeraldEvent>(
  event: E,
  props?: EmeraldEventProps[E],
): void {
  try {
    analytics.track(event, props ?? undefined);
  } catch {
    /* analytics is best-effort — never throw into the flow */
  }
}
